import React, { useMemo, useCallback } from 'react'
import Flex from 'components/reusable/flex'
import Text from 'components/reusable/text'
import ReferralShareSection from 'components/complex/referral_share_section'
import AuthHelper from 'helpers/auth_helper'
import RouterHelper from 'helpers/router_helper'
import { colors } from 'helpers/colors'
import {
  ModalWrapper,
  ImageSection,
  BannerImage,
  ContentSection,
} from './styled'
import ModalCloseButtonV2 from '../modal_close_button_v2'
import { dismissReferralAfterApplyModal } from 'helpers/referral_helpers'

const titleSize = [{ maxWidth: 768, size: 24 }, { size: 32 }]
const subtitleSize = [{ maxWidth: 768, size: 14 }, { size: 16 }]

function ReferralAfterApplyModal({ onClose }) {
  const referralCode = useMemo(() => AuthHelper.currentUser()?.referral_code, [])
  const url = useMemo(() => RouterHelper.getReferralLink(referralCode), [referralCode])

  const handleClose = useCallback(() => {
    dismissReferralAfterApplyModal()
    onClose()
  }, [onClose])

  return (
    <ModalWrapper>
      <ModalCloseButtonV2 onClose={handleClose} />

      <ImageSection>
        <BannerImage src="/images/backgrounds/you-are-on-roll.jpg" width="100%" height="100%" />
      </ImageSection>

      <ContentSection dir="column" jc="flex-start" ai="flex-start" gap={20}>
        <Flex dir="column" ai="flex-start" gap={8} width="100%">
          <Text size={titleSize} weight={500}>You're on a roll!</Text>
          <Text size={subtitleSize} color={colors.gray[500]} lineHeight="140%">
            Bring more opportunities to Swipecast.
          </Text>
        </Flex>

        <ReferralShareSection url={url} referrerRole="talent" showByInvitationOnly />
      </ContentSection>
    </ModalWrapper>
  )
}

export default ReferralAfterApplyModal
